import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../../../../axios/index';
import { Link } from 'react-router-dom';

// Context
import { UserContext } from './../../../Context/UserContextProvider';

// styles
import styles from "./AddNote.module.css"
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"
import inputStyles from "../../Meeting/AddMeeting/AddMeeting.module.css"
import 'react-toastify/dist/ReactToastify.css';

// Re Useable Components
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import { addNoteValidate } from './addNoteValidate';

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg"

const AddNote = () => {
    const { userToken } = useContext(UserContext);
    const history = useHistory()
    const [btnLoader, setBtnLoader] = useState(false)
    const [errors, setErrors] = useState({})
    const [addNoteInfo, setAddNoteInfo] = useState({
        title: "",
        description: ""
    })

    useEffect(() => {
        setErrors(addNoteValidate(addNoteInfo))
    }, [addNoteInfo])

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover={false}
                            theme="light"
                        />
                        <form onSubmit={(e) => e.preventDefault()} className={`mt-3 px-0 ${Dstyles.container}`}>
                            <DashboardHeader />
                            {/* head title */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-4 mb-2'>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                                <div className={Dstyles.text1}>
                                                    یادداشت‌ها
                                                </div>
                                            </div>

                                            {/* <Link to="/note-reminder" className={`d-flex align-items-center justify-content-center ms-3 ${reminderData.reminderStatus && "text-primary"} ${styles.add_btn_container}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={reminderData.reminderStatus ? "#21409A" : "#8D8D8D"} className="bi bi-alarm ms-2" viewBox="0 0 16 16">
                                            <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z" />
                                            <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z" />
                                        </svg>
                                        یادآور
                                    </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* head title */}

                            {/* inputs */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
                                            <div className="d-flex align-items-start justify-content-center flex-column my-3 w-100">
                                                <div className={`mb-3 ${inputStyles.input_top_title}`}>
                                                    عنوان یادداشت
                                                </div>
                                                <input
                                                    className={`w-100 ${inputStyles.input}`}
                                                    type="text"
                                                    name="title"
                                                    value={addNoteInfo.title}
                                                    onChange={changeHandler}
                                                />
                                            </div>
                                            <div className='w-100 d-flex flex-column justify-content-center align-items-start my-4'>
                                                <div className={`mb-3 ${inputStyles.input_top_title}`}>
                                                    متن یادداشت
                                                </div>
                                                <textarea
                                                    type="text"
                                                    name="description"
                                                    value={addNoteInfo.description}
                                                    className={`w-100 px-3 pt-3 ${styles.textarea}`}
                                                    onChange={changeHandler}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* inputs */}

                            <div className="py-2 mb-4">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-end justify-content-center flex-column'>
                                            {btnLoader ? (
                                                <div className={Dstyles.btn_loader_container}>
                                                    <div className={Dstyles.btn_spinner}></div>
                                                </div>
                                            )
                                                : (
                                                    <button type="submit" className={`btn ${styles.submit_btn}`} onClick={submitHandler}>
                                                        ثبت
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu notes />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    );

    function changeHandler(event) {
        setAddNoteInfo((prev) => {
            return { ...prev, [event.target.name]: event.target.value };
        });
    };

    function submitHandler() {
        if (!Object.keys(errors).length) {
            notify("درحال ایجاد یادداشت جدید", "success")
        } else {
            notify("!لطفا تمام فیلد هارا پرکنید", "error")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            postHandler()
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    async function postHandler() {
        setBtnLoader(true)
        const title = addNoteInfo.title;
        const description = addNoteInfo.description;

        var data = new FormData();
        data.append('Title', title);
        data.append('Description', description);

        const apiData = await axios.post(
            "Note",
            data,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        history.push('/my-notes')
        // setLoading(false)
    };
};

export default AddNote;